import React from "react";
import { useFcDimsAndWeightBackToProductDims } from "crossdock/modes/inspection/fc-dims-and-weight/buttons/backToProductDims/useFcDimsAndWeightBackToProductDims";
import { BackButton } from "@deliverr/ui-facility/lib-facility/components/buttons/common/facilityCommonsButtons";

export const FcDimsAndWeightBackToProductDimsButton: React.FC = () => {
  const { onClick } = useFcDimsAndWeightBackToProductDims();

  return <BackButton onClick={onClick} secondary block />;
};
